/**
 * 路由配置
 * 用途：前台页面 + 后台管理（需登录）
 * 用法：main.js 中 app.use(router)
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import AppLayout from '@/components/AppLayout.vue'
import HomePage from '@/views/HomePage.vue'
import ProductDetail from '@/views/ProductDetail.vue'
import CasesPage from '@/views/CasesPage.vue'
import CaseDetail from '@/views/CaseDetail.vue'
import ContactPage from '@/views/ContactPage.vue'
import AdminLogin from '@/views/admin/AdminLogin.vue'
import AdminLayout from '@/views/admin/AdminLayout.vue'
import AdminDashboard from '@/views/admin/AdminDashboard.vue'
import i18n from '@/i18n'
import { getToken } from '@/services/api'

const routes = [
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', name: 'home', component: HomePage, meta: { titleKey: 'meta.home' } },
      {
        path: 'product/:id',
        name: 'product-detail',
        component: ProductDetail,
        meta: { titleKey: 'meta.productDetail' }
      },
      { path: 'cases', name: 'cases', component: CasesPage, meta: { titleKey: 'meta.cases' } },
      {
        path: 'cases/:id',
        name: 'case-detail',
        component: CaseDetail,
        meta: { titleKey: 'meta.caseDetail' }
      },
      { path: 'contact', name: 'contact', component: ContactPage, meta: { titleKey: 'meta.contact' } }
    ]
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: AdminLogin,
    meta: { titleKey: 'meta.adminLogin', isAdmin: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, isAdmin: true },
    children: [
      {
        path: '',
        name: 'admin',
        component: AdminDashboard,
        meta: { titleKey: 'meta.admin', requiresAuth: true, isAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

function updateDocumentTitle(to) {
  const titleKey = to.meta.titleKey
  const pageTitle = titleKey ? i18n.global.t(titleKey) : 'DuoGu'
  document.title = `${pageTitle} | DuoGu Sourcing`
}

/** 后台鉴权：无 token 跳转登录页 */
router.beforeEach((to) => {
  if (to.matched.some((r) => r.meta.requiresAuth) && !getToken()) {
    return { name: 'admin-login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'admin-login' && getToken()) {
    return { name: 'admin' }
  }
  return true
})

router.afterEach((to) => {
  updateDocumentTitle(to)
})

export { updateDocumentTitle }
export default router
